module.exports = __webpack_public_path__ + "img/no_data.bd0df880.png";